import { Get, GetWithCommon, post, PostWithAccessToken, Put, PostWithCommon } from "../../helpers/http";
import { getSessionData } from "../../helpers/Util";



export const GetPatientDetails = async (caseId, companyId) => {
    return (await Get(`${process.env.REACT_APP_LAW_API_URL}Patient/patient-details?caseId=${caseId}&companyId=${companyId}`)).json()
    // return (await Get(`https://localhost:7092/api/Patient/patient-details?caseId=${caseId}&companyId=${companyId}`)).json()
};

export const UpdatePatientDetails = async (data) => {
    // return (await Put(`https://localhost:7092/api/Patient/update-patient-details`, data))
    return (await Put(`${process.env.REACT_APP_LAW_API_URL}Patient/update-patient-details`, data))
};

export const GetStateList = async () => {
    // return (await Get(`https://localhost:7092/api/Patient/get-state-list`)).json()
    return (await Get(`${process.env.REACT_APP_LAW_API_URL}Patient/get-state-list`)).json()
};

export const GetCaseTypeList = async (companyId) => {
    return (await Get(`${process.env.REACT_APP_LAW_API_URL}Patient/get-case-types?companyId=${companyId}`)).json()
    // return (await Get(`https://localhost:7092/api/Patient/get-case-types?companyId=${companyId}`)).json()
};

export const GetFormData = async (params) => {
    const response = await post(
        process.env.REACT_APP_EHR,
        "GenericForm/CaseFormListData",
        {
            CaseFormDataId: params.CaseFormDataId ?? 0,
            CaseId: params.CaseId ?? 0,
            CompanyId: params.CompanyId ?? "",
            UserId: params.UserId ?? "",
            DoctorId: params.DoctorId ?? "",
            OfficeId: params.OfficeId ?? "",
            OldCaseFormDataId: params.OldCaseFormDataId ?? 0,
            IsCopySign: params.IsCopySign ?? false,
            ProviderSign: params.ProviderSign ?? "",
            IsChanged: params.IsChanged ?? false,
            SavePdfInDocMgr: params.SavePdfInDocMgr ?? false,
            FormId: params.FormId ?? 0,
            FormName: params.FormName ?? "",
            TemplateName: params.TemplateName ?? "",
            EntityLevel: params.EntityLevel ?? 0,
            FormType: params.FormType ?? "",
            IsFormCompleted: params.IsFormCompleted ?? false,
            JsonData: params.JsonData ?? "",
            FileName: params.FileName ?? "",
            FilePath: params.FilePath ?? ""
        }
    );
    return response.data;
};

export const SaveFormData = async (params) => {
    const response = await post(
        process.env.REACT_APP_EHR,
        "GenericForm/SaveCaseFormData",
        {
            CaseFormDataId: params.CaseFormDataId ?? 0,
            CaseId: params.CaseId ?? 0,
            CompanyId: params.CompanyId ?? "",
            UserId: params.UserId ?? "",
            DoctorId: params.DoctorId ?? "",
            OfficeId: params.OfficeId ?? "",
            OldCaseFormDataId: params.OldCaseFormDataId ?? 0,
            IsCopySign: params.IsCopySign ?? false,
            ProviderSign: params.ProviderSign ?? "",
            IsChanged: params.IsChanged ?? false,
            SavePdfInDocMgr: params.SavePdfInDocMgr ?? false,
            FormId: params.FormId ?? 0,
            FormName: params.FormName ?? "",
            TemplateName: params.TemplateName ?? "",
            EntityLevel: params.EntityLevel ?? 0,
            FormType: params.FormType ?? "",
            IsFormCompleted: params.IsFormCompleted ?? false,
            JsonData: params.JsonData ?? "",
            FileName: params.FileName ?? "",
            FilePath: params.FilePath ?? ""
        }
    );
    return response.data;
};


function getIntakeContext() {
    const tokenData = JSON.parse(sessionStorage.getItem("tokenData") || "{}");
    const tokenSheets = JSON.parse(sessionStorage.getItem("tokenIntakeSheets") || "[]");

    return {
        companyId: tokenData.companyId || tokenData.CompanyId || "",
        caseId: tokenData.caseId || tokenData.CaseId || "",
        doctorId: tokenData.doctorId || tokenData.DoctorId || tokenData.physicianId || "",
        userId: tokenData.userId || tokenData.UserId || "",
        formMeta: tokenSheets[0] || {},   // FormId, FormName, FormType, TemplateName, EntityLevel
    };
}


export const CallSaveApiForIntakeSheet = async (collection, state, isChanged = false) => {
    const { companyId, caseId, doctorId, userId, formMeta } = getIntakeContext();

    const requestBody = {
        IsCopySign: false,
        CaseId: caseId,
        CaseFormDataId: state.CaseFormDataId || null,
        UserId: userId,
        IsFormCompleted: state.IsFormCompleted || false,
        FormId: formMeta.FormId || "",
        EntityLevel: formMeta.EntityLevel || "",
        TemplateName: formMeta.TemplateName || "",
        CompanyId: companyId,
        DoctorId: doctorId,
        FormName: formMeta.FormName || "",
        FormType: formMeta.FormType || "",
        JsonData: JSON.stringify(collection),
        IsChanged: isChanged,
    };

    return (
        await PostWithAccessToken(
            `${process.env.REACT_APP_API_BASE_URL}GenericForm/SaveCaseFormData`,
            requestBody
        )
    ).json();
};

export const CallSaveApiForIntakeSheetFrontDesk = async (collection, state, providerId, isChanged = false) => {
    const { companyId, caseId, userId, formMeta } = getIntakeContext();

    const requestBody = {
        IsCopySign: false,
        CaseId: caseId,
        CaseFormDataId: state.CaseFormDataId || null,
        UserId: userId,
        IsFormCompleted: state.IsFormCompleted || false,
        FormId: formMeta.FormId || "",
        EntityLevel: formMeta.EntityLevel || "",
        TemplateName: formMeta.TemplateName || "",
        CompanyId: companyId,
        DoctorId: providerId,
        FormName: formMeta.FormName || "",
        FormType: formMeta.FormType || "",
        JsonData: JSON.stringify(collection),
        officeId: providerId,
        IsChanged: isChanged,
    };

    return (
        await PostWithAccessToken(
            `${process.env.REACT_APP_API_BASE_URL}GenericForm/SaveCaseFormData`,
            requestBody
        )
    ).json();
};

export const GetDoctors = async (providerIds, companyId) => {
    return (await GetWithCommon(`${process.env.REACT_APP_CASE_VISIT_URL}Visit/DoctorsDDL?ProviderIds=${providerIds?.toString()}&CompanyId=${companyId}`)).json()
};

export const AddAppointment = async (payload) => {
    return (await PostWithCommon(`${process.env.REACT_APP_COMMONSERVICE_URL}Calendar/AddVisit`, payload)).json();
};

export const getVisitTypeBySpecialtyAndDoctor = async (caseId, specialtyIds) => {
    let url = specialtyIds ? '&specialtyIds=' + specialtyIds : ''
    return (await GetWithCommon(`${process.env.REACT_APP_CASE_VISIT_URL}Visit/GetVisitTypeByDoctorOrSpecialty?caseId=${caseId}` + url))
};

export const getVisitsForCheckin = async (caseId, companyId, visitDate) => {
    return (await Get(`${process.env.REACT_APP_LAW_API_URL}Patient/visits-for-checkin?caseId=${caseId}&companyId=${companyId}&visitDate=${visitDate}`)).json()
    // return (await Get(`https://localhost:7092/api/Patient/visits-for-checkin?caseId=${caseId}&companyId=${companyId}&visitDate=${visitDate}`)).json()
};

export const addCheckIn = async (data) => {
    return (await PostWithCommon(`${process.env.REACT_APP_COMMONSERVICE_URL}Common/CheckinFrontDesk`, data)).json();
    // return (await PostWithCommon(`https://localhost:7053/api/CommonServiceAPI/v1/Common/CheckinFrontDesk`, data))
};